export default __webpack_public_path__ + "static/media/UNIVERSITY OF GREENWICH.7f41e825.png";